<div class="datacenter-filter-date">
	<label class="filter-date-label" for="filter-date-from-input" translate>filter.date.from</label>
	<div class="filter-date-wraper">
		<mat-form-field class="no-padding" appearance="outline">
			<input class="filter-date-input"
				matInput
				id="filter-date-from-input"
				spellcheck="false"
				autocomplete="off"
				[placeholder]="'filter.date' | translate"
				[copoDatepicker]="datepickerFrom"
				[copoFormat]="model.format ?? 'date'"
				[formControl]="fromDateControl"
				(click)="datepickerFrom.open()"
				#startDateInput
				[max]="toDateControl.value"
				(dateChange)="onDateChange()"
				(typeChange)="onTypeChange($event)">
			<button type="button" *ngIf="fromDateControl.value" matSuffix mat-icon-button (click)="resetFromDate();" tabindex="-1">
				<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
			</button>
			<mat-datepicker-toggle matSuffix [for]="datepickerFrom"></mat-datepicker-toggle>
			<!-- About ag-custom-component-popup: https://www.ag-grid.com/javascript-data-grid/component-filter/#custom-filters-containing-a-popup-element-->
			<mat-datepicker panelClass="ag-custom-component-popup" #datepickerFrom></mat-datepicker>
		</mat-form-field>
	</div>
	<label class="filter-date-label" for="filter-date-to-input" translate>filter.date.to</label>
	<div class="filter-date-wraper">
		<mat-form-field class="no-padding" appearance="outline">
			<input class="filter-date-input"
				matInput
				id="filter-date-to-input"
				spellcheck="false"
				autocomplete="off"
				[placeholder]="'filter.date' | translate"
				[copoDatepicker]="datepickerTo"
				[copoFormat]="model.format ?? 'date'"
				[formControl]="toDateControl"
				(click)="datepickerTo.open()"
				#endDateInput
				[min]="fromDateControl.value"
				(dateChange)="onDateChange()"
				(typeChange)="onTypeChange($event)">
			<button type="button" *ngIf="toDateControl.value" matSuffix mat-icon-button (click)="resetToDate();" tabindex="-1">
				<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
			</button>
			<mat-datepicker-toggle matSuffix [for]="datepickerTo"></mat-datepicker-toggle>
			<!-- About ag-custom-component-popup: https://www.ag-grid.com/javascript-data-grid/component-filter/#custom-filters-containing-a-popup-element-->
			<mat-datepicker panelClass="ag-custom-component-popup" #datepickerTo></mat-datepicker>
		</mat-form-field>
	</div>
</div>